import PlanModuleCardList from "../components/Management/PlanModuleCardList";
import Overview from "../Pages/Dashboard/Overview";
import Invoice from "../Pages/InvoiceManagement/Invoice";
import Login from "../Pages/Login/login";
import CreateNewSubscription from "../Pages/Management/Create/CreateSubscription.js";
import OrganizationDashboard from "../Pages/Management/Dashboard";
import CreateOrganization from "../Pages/Management/Create/CreateOrganization.js";
import ManageSubscription from "../Pages/Management/ManageSubscription";
import EditOrganization from "../Pages/Management/Create/EditOrganization.js";
import PrivateLayout from "../Layout/PrivateLayout.js";
import PublicLayout from "../Layout/PublicLayout.js";
import Category from "../Pages/Category/Category.js";

export const routes = {
  private: [
    {
      path: "/dashboard",
      elem: Overview,
      layout: PrivateLayout,
    },
    {
      path: "/organization/management/dashboard",
      elem: OrganizationDashboard,
      layout: PrivateLayout,
    },
    {
      path: "/organization/create",
      elem: CreateOrganization,
      layout: PrivateLayout,
    },
    {
      path: "/organization/manage/subscription/:id",
      elem: ManageSubscription,
      layout: PrivateLayout,
    },
    {
      path: "/organization/edit/:id",
      elem: EditOrganization,
      layout: PrivateLayout,
    },
    {
      path: "/organization/manage/subscription/plans/:groupId/:subscriptionId",
      elem: PlanModuleCardList,
      layout: PrivateLayout,
    },
    {
      path: "/organization/create/subscription/:id",
      elem: CreateNewSubscription,
      layout: PrivateLayout,
    },
    {
      path: "/invoice/list",
      elem: Invoice,
      layout: PrivateLayout,
    },
    {
      path: "/category/list",
      elem: Category,
      layout: PrivateLayout,
    },
  ],
  public: [
    {
      path: "/gateway",
      elem: Login,
      layout: PublicLayout,
    },
  ],
};
